import { useEffect, useState } from 'react';
import {
  discoveryApiRef,
  fetchApiRef,
  useApi,
} from '@backstage/core-plugin-api';
import { WIKI_SECTIONS } from './wikiSections';

export interface SectionTarget {
  name: string;
  repo?: string;
  docsPath: string;
}

export function useWikiSections() {
  const discovery = useApi(discoveryApiRef);
  const { fetch } = useApi(fetchApiRef);
  const [sections, setSections] = useState<SectionTarget[]>(WIKI_SECTIONS);
  const [defaultLegacyRepo, setDefaultLegacyRepo] = useState<string>();
  const [wikiRepos, setWikiRepos] = useState<string[]>();
  const [gitlabBaseUrl, setGitlabBaseUrl] = useState(
    'https://gitlab.afbaws.com',
  );

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const base = await discovery.getBaseUrl('wiki-import');
        const r = await fetch(`${base}/status`);
        if (!r.ok) return;
        const data = await r.json();
        if (cancelled) return;
        if (data.gitlabBaseUrl) setGitlabBaseUrl(data.gitlabBaseUrl);
        if (data.defaultLegacyRepo) setDefaultLegacyRepo(data.defaultLegacyRepo);
        if (Array.isArray(data.wikiRepos)) setWikiRepos(data.wikiRepos);
        if (Array.isArray(data.sections) && data.sections.length > 0)
          setSections(data.sections);
      } catch {
        return;
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [discovery, fetch]);

  return { sections, defaultLegacyRepo, wikiRepos, gitlabBaseUrl };
}
